import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const SA_API = `${BASE}/api`;

// Istanza separata dall'auth dipendenti: su 401 reindirizza al login Superadmin.
const saApi = axios.create({ baseURL: SA_API, withCredentials: true });

saApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const p = window.location.pathname;
      if (p.startsWith("/superadmin") && !p.includes("/superadmin/login")) {
        window.location.href = "/superadmin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default saApi;
